import Http from '@/api/http.js'
import HttpRetail from '@/api/http_retail.js';

export default {

  index() {
    return Http.get(`/stocks`)
  },

  indexByModel({model = 'modalities', id, brand_id}) {
    return Http.get(`${model}/${id}/stocks`, {params: {brand_id}})
  },

  update(stock){
    return Http.put(`/stocks/${stock.id}`, {
      stock: {...stock},
    });
  },
  updateBatch(stock){
    return Http.put(`/stocks/${stock.id}`, {
      stock: {...stock},
    });
  },

  show(id) {
    return Http.get(`/stocks/${id}`);
  },

  manualCount(manual_stocks){
    return Http.post(`/stocks/manual_count`, {
      manual_stocks
    });
  },

  manualCountComment(movements){
    return Http.post(`/stocks/manual_count_comment`, {
      movements
    });
  },

  indexConference(params) {
    return Http.get(`/stock_conferences`, {params: {...params}})
  },
  createConference(stock) {
    return Http.post(`/stock_conferences`, {stock_conference: {...stock}})
  },




  indexMovement({modality_id, product_id, brand_id, start_date, end_date}) {
    /*
      modality_id, -> pode ser para model/model_id/movements
      product_id,
      brand_id,
      start_date,
      end_date,
    */
    return Http.get(`modalities/${modality_id}/movements`, { 
      params: {
        product_id, brand_id, start_date, end_date
      }
    })
  },

  createMovement(movement){
    return Http.post(`/movements`, { 
      movement: {
        ...movement
      }
    })
  },

  indexByModelHttpRetail({model = 'modalities', id, brand_id, params}) {
    return HttpRetail.get(`${model}/${id}/stocks`, {params: {brand_id, ...params}})
  },
  indexHttpRetail() {
    return HttpRetail.get(`/stocks`)
  },

}
